var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import React from "react";
import styled from "styled-components";
var SidebarWrapper = styled.aside(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), function (_a) {
    var theme = _a.theme;
    return "\n    display: flex;\n    flex-direction: column;\n    border-left: 1px solid ".concat(theme.borderContent(), ";\n    border-right: 1px solid ").concat(theme.borderContent(), ";\n  ");
});
var Sidebar = function (_a) {
    var children = _a.children;
    return React.createElement(SidebarWrapper, null, children);
};
export default Sidebar;
var templateObject_1;
